export default class MenuItemActive {
    constructor($root) {
        this.$root = $root;
        this.items = [];
        this.frame = null;
        this.isReady = false;

        this.onPageShow = this.onPageShow.bind(this);
        this.onViewportChange = this.onViewportChange.bind(this);

        this.init();
    }

    init() {
        this.items = this.getItems();

        if (!this.items.length) {
            return;
        }

        this.setInitializingState(true);
        this.setActiveItem(null);

        window.addEventListener('pageshow', this.onPageShow);
        window.addEventListener('scroll', this.onViewportChange, {passive: true});
        window.addEventListener('resize', this.onViewportChange, {passive: true});
        window.addEventListener('hashchange', this.onViewportChange);
    }

    getItems() {
        const itemsBySection = new Map();

        this.$root.querySelectorAll('[data-menu-link]').forEach($link => {
            const url = new URL($link.href, window.location.href);

            if (!this.isCurrentPage(url) || !url.hash || url.hash === '#') {
                return;
            }

            const $section = this.getSection(url.hash);

            if (!$section) {
                return;
            }

            if (!itemsBySection.has($section)) {
                itemsBySection.set($section, {
                    $section,
                    $links: []
                });
            }

            itemsBySection.get($section).$links.push($link);
        });

        return Array.from(itemsBySection.values());
    }

    isCurrentPage(url) {
        return url.origin === window.location.origin &&
            this.normalizePath(url.pathname) === this.normalizePath(window.location.pathname);
    }

    normalizePath(path) {
        return path.replace(/\/+$/, '') || '/';
    }

    getSection(hash) {
        try {
            return document.getElementById(decodeURIComponent(hash.substring(1)));
        } catch (e) {
            return null;
        }
    }

    onPageShow() {
        const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

        fontsReady.then(() => {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    this.isReady = true;
                    this.updateActiveItem();

                    window.requestAnimationFrame(() => this.setInitializingState(false));
                });
            });
        });
    }

    onViewportChange() {
        if (!this.isReady || this.frame) {
            return;
        }

        this.frame = window.requestAnimationFrame(() => {
            this.frame = null;
            this.updateActiveItem();
        });
    }

    updateActiveItem() {
        const activationLine = Math.min(
            window.innerHeight - 1,
            Math.max(0, this.$root.getBoundingClientRect().bottom + 1)
        );
        const activeItem = this.items.find(item => {
            const bounds = item.$section.getBoundingClientRect();

            return bounds.top <= activationLine && bounds.bottom > activationLine;
        });

        this.setActiveItem(activeItem || null);
    }

    setActiveItem(activeItem) {
        this.items.forEach(item => {
            const isActive = item === activeItem;

            item.$links.forEach($link => {
                if ($link.classList.contains('header-menu__link')) {
                    $link.classList.toggle('header-menu__link--active', isActive);
                }

                if ($link.classList.contains('header-menu-mobile__link')) {
                    $link.classList.toggle('header-menu-mobile__link--active', isActive);
                }
            });
        });
    }

    setInitializingState(isInitializing) {
        this.items.forEach(item => {
            item.$links.forEach($link => {
                if ($link.classList.contains('header-menu__link')) {
                    $link.classList.toggle('header-menu__link--scrollspy-initializing', isInitializing);
                }
            });
        });
    }
}
